import { render, staticRenderFns } from "./FloatingComponents.vue?vue&type=template&id=fe387a68&scoped=true"
import script from "./FloatingComponents.vue?vue&type=script&lang=js"
export * from "./FloatingComponents.vue?vue&type=script&lang=js"
import style0 from "./FloatingComponents.vue?vue&type=style&index=0&id=fe387a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe387a68",
  null
  
)

export default component.exports